'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.public-header', []).directive('fPublicHeader', function () {
  return {
    restrict: 'E',
    template: '<div><div class="sub-toolbar" layout="column" layout-gt-xs="row" layout-align="center start" layout-align-gt-xs="start center" ng-transclude></div></div>',
    transclude: true,
    replace: true
  };
});


//////////////////
// WEBPACK FOOTER
// ./public-header/index.js
// module id = 501
// module chunks = 0